<td>{{name}}</td>
<td class="tools">
	<a href="/deployment/server/{{name}}"><i class="icon-pencil"></i></a>
	<i class="icon-trash delete"></i>
	<i class="icon-cloud-upload deploy-button" title="Deploy"></i>
</td>
